import { createContext } from "react";
import { SignUpContextData } from "./types";

export const SignUpContext = createContext({} as SignUpContextData);
